import { render, staticRenderFns } from "./FloatingInfoBox.vue?vue&type=template&id=260c38d2&scoped=true&"
import script from "./FloatingInfoBox.vue?vue&type=script&lang=js&"
export * from "./FloatingInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./FloatingInfoBox.vue?vue&type=style&index=0&id=260c38d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c38d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260c38d2')) {
      api.createRecord('260c38d2', component.options)
    } else {
      api.reload('260c38d2', component.options)
    }
    module.hot.accept("./FloatingInfoBox.vue?vue&type=template&id=260c38d2&scoped=true&", function () {
      api.rerender('260c38d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/FloatingInfoBox.vue"
export default component.exports